module.exports = __webpack_public_path__ + "static/media/pass-4-bw.c27e2365.png";